import React from "react";

const TitleUnderline = () => {
	return <div className="title-underline"></div>;
};

export default TitleUnderline;
